import React from 'react';
import {View} from 'react-native';
import {BS_CARD_TYPES} from '../../../utils/Constants';
import {DLog} from '../../../utils/HelperMethods';
import BloodSugarCard from '../BloodSugarCard';
import styles from './styles';

const BloodSugarCardModule = ({homeMode = false, min, max, readings}) => {
  //mode can be home or blood sugar history
  return homeMode ? (
    <View style={styles.bloodSugarCardModule}>
      <View style={styles.flexPoint5}>
        <BloodSugarCard
          variation={BS_CARD_TYPES.SwipableCard}
          title="Last Entry"
          value={
            readings.data[readings.data.length - 1].diabetesMeasurement
              .bloodSugarCount
          }
          min={min}
          max={max}
          readings={readings}
        />
      </View>

      <View style={styles.flexPoint5}>
        <View style={styles.flexPoint5}>
          <BloodSugarCard
            variation={BS_CARD_TYPES.SmallCard}
            title="Day's Avg"
            value={Math.floor(readings?.average)}
            min={min}
            max={max}
          />
        </View>
        <View style={styles.flexPoint5}>
          <BloodSugarCard
            variation={BS_CARD_TYPES.SmallCard}
            title="Weekly Avg"
            value={Math.floor(readings?.weekAverage)}
            min={min}
            max={max}
          />
        </View>
      </View>
    </View>
  ) : (
    <View style={styles.bloodSugarCardModule}>
      <View style={styles.flexPoint5}>
        <BloodSugarCard
          variation={BS_CARD_TYPES.BigCard}
          title="Period Avg"
          value={
            isNaN(Math.floor(readings?.average))
              ? '-'
              : Math.floor(readings?.average)
          }
          min={min}
          max={max}
        />
      </View>

      <View style={styles.flexPoint5}>
        <View style={styles.flexPoint5}>
          <BloodSugarCard
            variation={BS_CARD_TYPES.SmallCard}
            title="Highest"
            value={
              isNaN(Math.floor(readings?.highestReading))
                ? '-'
                : Math.floor(readings?.highestReading)
            }
            min={min}
            max={max}
          />
        </View>
        <View style={styles.flexPoint5}>
          <BloodSugarCard
            variation={BS_CARD_TYPES.SmallCard}
            title="Lowest"
            value={
              isNaN(Math.floor(readings?.lowestReading))
                ? '-'
                : Math.floor(readings?.lowestReading)
            }
            min={min}
            max={max}
          />
        </View>
      </View>
    </View>
  );
};

export default BloodSugarCardModule;
